/*
  Klarna on-site messaging — Luminaire Lighting.

  Keeps the instalment figure in step with the variant the shopper has
  selected. This lives in a theme asset rather than inside the snippet
  because Shopify strips script tags out of custom_liquid output, so the
  block cannot carry its own JavaScript. Loaded from layout/theme.liquid.

  Markup contract — see snippets/lum-klarna.liquid:
    [data-lum-kl]        the block itself
    data-kl-prices       "variantId:priceInCents:availableFlag,..." (flag 1 or 0)
    data-kl-min          below this, the block hides
    data-kl-max          above this, no instalment figure is named
    data-kl-currency     ISO code for formatting
    [data-kl-msg]        the element whose text is rewritten

  The block also hides on a variant that cannot be bought, so a finance
  offer never sits above a greyed-out Add to Cart button.
*/
(function () {
  'use strict';

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('en-IE', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (e) {
      return (currency === 'EUR' ? '€' : '') + (cents / 100).toFixed(2);
    }
  }

  function setup(root) {
    if (root.dataset.klReady) return;
    root.dataset.klReady = '1';

    var min = parseInt(root.dataset.klMin, 10);
    var max = parseInt(root.dataset.klMax, 10);
    var currency = root.dataset.klCurrency || 'EUR';
    var msg = root.querySelector('[data-kl-msg]');
    if (!msg || isNaN(min) || isNaN(max)) return;

    var variants = {};
    (root.dataset.klPrices || '').split(',').forEach(function (entry) {
      var bits = entry.split(':');
      if (bits.length === 3) {
        variants[bits[0]] = {
          price: parseInt(bits[1], 10),
          available: bits[2] === '1'
        };
      }
    });

    function paint(v) {
      if (!v || isNaN(v.price) || v.price < min || !v.available) {
        root.style.display = 'none';
        return;
      }
      var cents = v.price;
      root.style.display = 'flex';
      if (cents > max) {
        msg.textContent = 'Spread the cost with Klarna';
        return;
      }
      msg.innerHTML = 'Pay in 3 interest-free payments of ' +
        '<strong style="font-weight:700;white-space:nowrap"></strong>';
      msg.querySelector('strong').textContent = money(Math.floor(cents / 3), currency);
    }

    var scope = root.closest('.shopify-section') || document;
    var input = scope.querySelector('form[action*="/cart/add"] [name="id"]');
    if (!input) return;

    var last = null;
    function check() {
      if (input.value === last) return;
      last = input.value;
      paint(variants[input.value]);
    }
    function checkSoon() {
      // let the theme's own variant handler update the hidden input first
      setTimeout(check, 50);
    }

    check();
    scope.addEventListener('change', checkSoon);
    scope.addEventListener('click', checkSoon);
    document.addEventListener('variant:change', checkSoon);
    try {
      new MutationObserver(check).observe(input, {
        attributes: true,
        attributeFilter: ['value']
      });
    } catch (e) {}
  }

  function boot() {
    document.querySelectorAll('[data-lum-kl][data-kl-prices]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
